<template>
  <div class="popup-contain">
    <div class="save-event-contain">
      <p v-if="detail.repeats === 1">This is a repeating event.</p>
      <p v-else>This is not a repeating event.</p>
      <template v-if="!cancel && !unCancel">
        <div
          class="save-this-event"
          @click.prevent.stop="singleDeleteLocal('delete')"
          v-if="detail.repeats === 1"
        >
          Delete this event only
        </div>
        <div
          class="save-this-event"
          @click.prevent.stop="singleDeleteLocal('delete')"
          v-else
        >
          Delete
        </div>
        <div
          class="save-future-event"
          v-if="detail.repeats === 1"
          @click.prevent.stop="futureDeleteLocal('delete')"
        >
          Delete this and future events
        </div>
        <div
          class="save-future-event"
          v-if="detail.repeats === 1"
          @click.prevent.stop="allDeleteLocal('delete')"
        >
          Delete all events
        </div>
      </template>

      <template v-else-if="cancel">
        <div
          class="save-this-event"
          @click.prevent.stop="singleDeleteLocal('cancel')"
        >
          Cancel this event only
        </div>
        <div
          class="save-future-event"
          v-if="detail.repeats === 1"
          @click.prevent.stop="futureDeleteLocal('cancel')"
        >
          Cancel future events
        </div>
        <div
          class="save-future-event"
          v-if="detail.repeats === 1"
          @click.prevent.stop="allDeleteLocal('cancel')"
        >
          Cancel all events
        </div>
      </template>

      <template v-else>
        <div
          class="save-this-event"
          @click.prevent.stop="singleDeleteLocal('un-cancel')"
        >
          Un-cancel this event only
        </div>
        <div
          class="save-future-event"
          v-if="detail.repeats === 1"
          @click.prevent.stop="futureDeleteLocal('un-cancel')"
        >
          Un-cancel future events
        </div>
        <div
          class="save-future-event"
          v-if="detail.repeats === 1"
          @click.prevent.stop="allDeleteLocal('un-cancel')"
        >
          Un-cancel all events
        </div>
      </template>
    </div>
    <div class="cancel-contain" @click.stop.prevent="hide">Cancel</div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    hide: Function, //Method to hide popup
    cancel: Boolean, // Check if we are trying to cancel appointment
    unCancel: Boolean // Check if we are trying to uncancel an appointment
  },
  computed: {
    ...mapGetters({
      details: "getDetail" // get details of all the appointments
    }),
    /**
     * Return method from url
     */
    id() {
      return !isNaN(this.$route.params.id)
        ? parseInt(this.$route.params.id)
        : false;
    },
    /**
     * Appointment detail for current appointment
     */
    detail() {
      return this.id && this.id in this.details ? this.details[this.id] : false;
    }
  },
  methods: {
    ...mapActions({
      deleteSingle: "deleteSingle",
      deleteFuture: "deleteFuture",
      deleteAll: "deleteAll"
    }),
    singleDeleteLocal(value) {
      this.deleteSingle({ id: this.id, deleteOrCancel: value });
      this.hide();
    },
    futureDeleteLocal(value) {
      this.deleteFuture({ id: this.id, deleteOrCancel: value });
      this.hide();
    },
    allDeleteLocal(value) {
      this.deleteAll({ id: this.id, deleteOrCancel: value });
      this.hide();
    }
  }
};
</script>
